/**
 * @author Leonel Martinez
 * @fileoverview Collection of helpful methods
 */

import { STATES } from "./enums/states";
import { router } from "./router";
import jsPDF from 'jspdf';
import autotable from 'jspdf-autotable';

/**
 * @description Remove null properties from an object
 * @param {obj} object the prop to be removed 
 */
export const removeNulls = obj => {
  let newObj = {};
  Object.keys(obj).forEach(prop => {
    if (obj[prop] !== null) {
      newObj[prop] = obj[prop];
    }
  });
  return newObj;
};

/** 
 * @description Use the `hasOwnProperty` method on recursively on nested objects.
 * @param {obj} obj Object to be tested
 * @prop {string} property List of the properties to be tested  
 * @returns {boolean}
 * @example hasNestedProperty(object, level1, level2, n...) // true or false
 */
export const hasNestedProperty = (obj, ...args) => {
  for (let i = 0; i < args.length; i++) {
    if (!obj || !obj.hasOwnProperty(args[i])) {
      return false;
    }
    obj = obj[args[i]];
  }
  return true;
};

export const searchForState = (string) => {
  return STATES.find(item => {
    return string.toLowerCase().startsWith(item.name.toLowerCase() + " ") || string.toLowerCase().startsWith(item.abbreviation.toLowerCase() + " ");
  });
};

// Debounce makes sure only the last call of the same function is executed after a set delay
export const debounce = (func, wait) => {
  let handler;

  return function () {
    if (handler)
      clearTimeout(handler);

    handler = setTimeout(async () => await func.apply(this, arguments), wait);
  }
}

export const filter = (obj, search) => {
  const regExp = new RegExp(search, "gi");

  const check = val => {
    if (typeof val === "object" && "thumbnailURL" in val) {
      val = { ...val };
      delete val.thumbnailURL;
      delete val.id;
      delete val.hasC2C;
      delete val.catalogOrderNumber;
    }

    if (val && typeof val === "object")
      return Object.values(val).some(check);

    if (Array.isArray(val))
      return val.some(check);

    return (
      (typeof val === "string" || typeof val === "number") &&
      regExp.test(val)
    );
  }

  return check(obj);
}

export const inPage = page =>
  router.app.$route.name == page;

export const to = name =>
  {
    console.log("name", name);
    console.log("provider",router.app.$route.params.provider )
    router.app.$router.push({ name: name, params: {provider: router.app.$route.params.provider} });
  }


export const print = (selected_parts) => {
  const pdf = new jsPDF();

  autotable(pdf, {
    didDrawCell: data => {
      if (data.section === 'body' && data.column.index === 0 && !(data.row.index % 2)) {
        if (selected_parts[data.row.index][6] && selected_parts[data.row.index][6].includes('base64')) {
          const base64Img = selected_parts[data.row.index][6];
          pdf.addImage(base64Img, 'JPEG', data.cell.x + 2, data.cell.y, 10, 10)
        }
      }
    },
    theme: 'plain',
    headStyles: { textColor: '#969696' },
    columns: [
      { header: 'MINIATURA', dataKey: 'thumbnail' },
      { header: 'DESCRIPCIÓN', dataKey: 'description' },
      { header: 'MFG', dataKey: 'mfg' },
      { header: '# DE PARTE', dataKey: 'part_number' },
      { header: 'AÑOS', dataKey: 'year' },
      { header: 'CANTIDAD POR VEHÍCULO', dataKey: 'quantity' },
    ],
    body: selected_parts
  });

  // if(this)
    // pdf.save("Part-list.pdf");
  pdf.output('dataurlnewwindow')
};